"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import { UIMenuItem, UIMenus } from "@/components/menu/item";
import API from "@ym-framework/api-utils";
export class Controller {
  constructor() {
    this._menus = new UIMenus();
  }
  get menus() {
    return this._menus;
  }
}
let ItemElementMenu = class extends Mixins(AccountSessionMixins) {
  handleCommand(command) {
    const _menu = this._controller.menus.use(command);
    if (_menu == null ? void 0 : _menu.command) {
      _menu.command();
    }
  }
  handleSubMenuCommand(command) {
    if (command.menu) {
      command.menu.command();
    }
  }
  created() {
    const VdManagementMap = /* @__PURE__ */ new Map();
    VdManagementMap.set(
      "setting",
      new UIMenuItem(this.$t("vdcontainer.vd_setting").toString()).action(() => {
        this.$router.push({
          name: "VdSettingView",
          query: {
            vd_id: this._item.id
          }
        });
      }).visible(() => {
        return this.$session.marks.any(
          "SYS:VD_MANAGEMENT:VD_SETTING",
          "SYS:ALL_MODULE"
        ) && this._item.marks.is("IS_ADMIN");
      })
    );
    VdManagementMap.set(
      "changeName",
      new UIMenuItem(this.$t("vdcontainer.modify_name").toString()).action(() => {
        this.$emit("changename");
      }).visible(() => {
        return this._item.marks.is("IS_ADMIN");
      })
    );
    VdManagementMap.set(
      "updateIp",
      new UIMenuItem(this.$t("vdcontainer.upgrade").toString()).action(() => {
        this.$router.push({
          name: "payment",
          query: {
            style: "update"
          },
          params: {
            item: JSON.stringify(this._item)
          }
        });
      }).visible(() => {
        return this.$session.marks.any(
          "SYS:VD_MANAGEMENT:UPGRADE_IP",
          "SYS:ALL_MODULE"
        ) && this.$session.permissions.any("VD_UPGRADE", "SHOW_ALL_MENUS") && this._item.status !== "wait" && this._item.status !== "configuring" && !this._item.marks.is("NOT_ALLOW_UPGRADE");
      })
    );
    VdManagementMap.set(
      "bindIp",
      new UIMenuItem(this.$t("vdcontainer.binding").toString()).action(() => {
        this.$emit("bindIP");
      }).visible(() => {
        return this.$session.marks.any(
          "SYS:VD_MANAGEMENT:BINDING_LOCAL_IP",
          "SYS:ALL_MODULE"
        ) && this._item.type === "local" && this._item.marks.is("IS_ADMIN");
      })
    );
    VdManagementMap.set(
      "unstickToTop",
      new UIMenuItem(this.$t("vdcontainer.unstick_to_the_top").toString()).action(() => {
        this.$emit("unstickToTop");
      }).visible(() => {
        return this._item.marks.is("TOP");
      })
    );
    VdManagementMap.set(
      "stickToTop",
      new UIMenuItem(this.$t("vdcontainer.stick_to_the_top").toString()).action(() => {
        this.$emit("stickToTop");
      }).visible(() => {
        return !this._item.marks.is("TOP");
      })
    );
    VdManagementMap.set(
      "editGroup",
      new UIMenuItem(this.$t("vdcontainer.grouping").toString()).action(() => {
        this.$emit("editGroup");
      })
    );
    VdManagementMap.set(
      "proxyShare",
      new UIMenuItem(this.$t("vdcontainer.proxy_share").toString()).action(() => {
        this.$emit("proxyShare");
      }).visible(() => {
        return this._item.marks.is("IS_ADMIN") && this._item.marks.is("PROXY_SHARE_LINK") && this._item.status !== "wait" && this._item.status !== "configuring";
      })
    );
    const ShopManagementMap = /* @__PURE__ */ new Map();
    ShopManagementMap.set(
      "editShop",
      new UIMenuItem(this.$t("vdcontainer.binding_shop").toString()).action(() => {
        this.$emit("editshop");
      }).visible(() => {
        return this.$session.marks.any(
          "SYS:VD_MANAGEMENT:BINDING_SHOP",
          "SYS:ALL_MODULE"
        ) && this._item.marks.is("IS_ADMIN") && !this._item.marks.is("NOT_ALLOW_BIND_SHOP");
      })
    );
    ShopManagementMap.set(
      "moveShop",
      new UIMenuItem(this.$t("vdcontainer.store_migration").toString()).action(() => {
        this.$emit("moveshop");
      }).visible(() => {
        return this.$session.marks.any(
          "SYS:VD_MANAGEMENT:STORE_RELOCATION",
          "SYS:ALL_MODULE"
        ) && this._item.marks.is("IS_ADMIN") && !this._item.marks.is("NOT_ALLOW_COPY_SHOP");
      })
    );
    this._controller.menus.add(
      "renew",
      new UIMenuItem(this.$t("vdcontainer.renewal").toString()).action(() => __async(this, null, function* () {
        try {
          let arr = [];
          arr.push(this._item.oldId);
          yield API.post(
            `api://base.auth/api/v7/payment/virtualdesktop-verification/renew`,
            {
              ids: arr
            }
          );
          this.$router.push({
            name: "payment",
            query: {
              style: "renew"
            },
            params: {
              item: JSON.stringify(this._item)
            }
          });
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      })).visible(() => {
        return this.$session.permissions.any(
          "PAY_ORDER",
          "VD_RENEW",
          "SHOW_ALL_MENUS"
        ) && this._item.status !== "wait";
      })
    );
    this._controller.menus.add(
      "addShop",
      new UIMenuItem(this.$t("vdcontainer.add_store").toString()).action(() => {
        this.$emit("createShop");
      }).visible(() => {
        return this.$session.marks.any(
          "SYS:VD_MANAGEMENT:ADD_SHOP",
          "SYS:ALL_MODULE"
        ) && this._item.marks.is("IS_ADMIN") && !this._item.marks.is("NOT_ALLOW_CREATE_SHOP") || this.$session.permissions.is("SHOP_CREATE") && this.$session.type === "user" && !this._item.marks.is("NOT_ALLOW_CREATE_SHOP");
      })
    );
    this._controller.menus.add(
      "vd-management",
      new UIMenuItem(this.$t("vdcontainer.vd_management").toString()).childrens(
        VdManagementMap
      )
    );
    this._controller.menus.add(
      "shop-management",
      new UIMenuItem(
        this.$t("vdcontainer.shop_management").toString()
      ).childrens(ShopManagementMap)
    );
    this._controller.menus.add(
      "proxySetting",
      new UIMenuItem(this.$t("vdcontainer.configure_agent").toString()).action(() => {
        this.$emit("proxySetting");
      }).visible(() => {
        return this._item.type === "selfConfigure" && this._item.marks.is("IS_ADMIN", "CAN_BIND_IP") && !this._item.marks.is("NO_EDIT_PROXY");
      })
    );
    this._controller.menus.add(
      "chooseAdmin",
      new UIMenuItem(this.$t("vdcontainer.assign_administrator").toString()).action(() => {
        this.$emit("chooseAdmin");
      }).visible(() => {
        var _a, _b, _c;
        return (!((_a = this.$session) == null ? void 0 : _a.permissions.is("FORBIDDEN_AUTH_VD_MANAGER")) && ((_b = this.$session) == null ? void 0 : _b.type) === "user" || ((_c = this.$session) == null ? void 0 : _c.type) === "account") && this.$session.marks.any(
          "SYS:VD_MANAGEMENT:ASSIGN_ADMIN",
          "SYS:ALL_MODULE"
        ) && this._item.marks.is("IS_ADMIN");
      })
    );
    this._controller.menus.add(
      "clearCache",
      new UIMenuItem(this.$t("vdcontainer.delete_cache").toString()).action(() => {
        this.$emit("clearCache");
      }).visible(() => {
        return this._item.status !== "wait" && this._item.status !== "configuring";
      })
    );
    this._controller.menus.add(
      "proxyShare",
      new UIMenuItem(this.$t("vdcontainer.proxy_share").toString()).action(() => {
        this.$emit("proxyShare");
      }).visible(() => {
        return this._item.marks.is("IS_ADMIN") && this._item.marks.is("PROXY_SHARE_LINK") && this._item.status !== "wait" && this._item.status !== "configuring";
      })
    );
    this._controller.menus.add(
      "deleteVD",
      new UIMenuItem(this.$t("vdcontainer.release").toString()).action(() => {
        this.$emit("deleteVD");
      }).visible(() => {
        return this._item.marks.is("IS_ADMIN") && !this._item.marks.is("NOT_ALLOW_DEL");
      })
    );
    this._controller.menus.add(
      "moveVD",
      new UIMenuItem(this.$t("vdcontainer.transfer").toString()).action(() => {
        this.$emit("moveVD");
      }).visible(() => {
        return this.$session.marks.is("CAN_TRANSFER_VD") && !this._item.marks.is("NOT_ALLOW_DEL");
      })
    );
  }
  mounted() {
  }
  checkShowSubMenu(children) {
    let flag = false;
    for (let [name, childMenu] of children.entries()) {
      if (childMenu.isVisible) {
        flag = true;
        break;
      }
    }
    if (!flag) {
      return false;
    } else {
      return true;
    }
  }
};
__decorateClass([
  PropSync("item")
], ItemElementMenu.prototype, "_item", 2);
__decorateClass([
  PropSync("controller", {
    default: () => {
      return new Controller();
    }
  })
], ItemElementMenu.prototype, "_controller", 2);
ItemElementMenu = __decorateClass([
  Component({})
], ItemElementMenu);
export {
  ItemElementMenu as default
};
